import { render, staticRenderFns } from "./Querys.vue?vue&type=template&id=1f346378&scoped=true"
import script from "./Querys.vue?vue&type=script&lang=js"
export * from "./Querys.vue?vue&type=script&lang=js"
import style0 from "./Querys.vue?vue&type=style&index=0&id=1f346378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f346378",
  null
  
)

export default component.exports